import Rails from "@rails/ujs"

import "./jquery_global"

import './mypage/js/header'
import './mypage/js/entry_form'

Rails.start()

$('#step-open').on('click', function() {
  return false;
});
